<template>
   <span data-cy="loading-spinner">
      <span v-if="screenReaderText" class="sr-only" aria-live="polite">{{ screenReaderText }}</span>

      <span class="mx-auto block" :class="sizeClass" aria-hidden="true">
         <DNASpinner :color="color" :alt="screenReaderText" />
      </span>
   </span>
</template>

<script setup lang="ts">
import { useI18n } from "@/vue-i18n/vue-i18n";
import DNASpinner from "./DNASpinner.vue";

const { t: $t } = useI18n();

interface Props {
   color?: "white" | "grey" | "default";
   screenReaderText?: string;
   size?: "sm" | "md" | "lg" | "xl" | "full";
}
const props = withDefaults(defineProps<Props>(), {
   color: "default",
   diameterRem: 2,
   size: "sm",
});

const screenReaderText = computed(() => {
   return props.screenReaderText || $t("system.loading");
});

const sizeClass = computed(() => {
   let sizeClass = "w-12 h-12";

   if (props.size === "sm") {
      sizeClass = "w-12 h-12";
   } else if (props.size === "md") {
      sizeClass = "w-20 h-20";
   } else if (props.size === "lg") {
      sizeClass = "w-24 h-24";
   } else if (props.size === "full") {
      sizeClass = "w-full h-full";
   }
   return sizeClass;
});
</script>

<style scoped lang="scss">
.loading-spinner {
   @apply mx-auto;
   overflow: hidden;
   border-left: 0.2rem solid rgba(255, 255, 255, 0);
   transform: translateZ(0);
   animation: LoadingSpinner 1.1s infinite linear;
}

.loading-spinner,
.loading-spinner:after {
   border-radius: 50%;
}

.loading-spinner:after {
   @apply w-full h-full;
}

@keyframes LoadingSpinner {
   0% {
      transform: rotate(0deg);
   }
   100% {
      transform: rotate(360deg);
   }
}
</style>
